const users = [
  {
    path: '/participants',
    name: 'participants.list',
    component: () => import('@/views/participants/ParticipantList.vue'),
  },
  {
    path: '/participants/unsubscribe-requests',
    name: 'unsubscribe-requests.list',
    component: () => import('@/views/participants/UnsubscribeRequest.vue'),
    meta: { roles: ['super_admin', 'admin'] },
  },
  {
    path: '/participants/:uuid',
    name: 'participants.show',
    component: () => import('@/views/participants/ParticipantShow.vue'),
  },
]

export default users
